import { AbstractModel } from '@patsnap/tahiti-core';
import { CurrentMatchedDocModel } from '../current-matched-doc-model';
import type { CurrentMatchedDocState } from '../../types';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

function createInitialMatchedDocState(): CurrentMatchedDocState {
    return {
        ranking: [],
        manualAdded: [],
        extraAdded: [],
    };
}

@injectable()
export class CurrentMatchedDocModelImpl extends AbstractModel<CurrentMatchedDocState> implements CurrentMatchedDocModel {
    protected _modelData: CurrentMatchedDocState = createInitialMatchedDocState();

    clone(data: CurrentMatchedDocState): CurrentMatchedDocState {
        return data;
    }

    dispose(): void {
        this.update(() => createInitialMatchedDocState());
    }
}
